import { render } from "./TheModalVideo.vue?vue&type=template&id=716040e6"
import script from "./TheModalVideo.vue?vue&type=script&lang=js"
export * from "./TheModalVideo.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__